export { TabComponent } from './TabComponent';
